import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export interface WhatsAppHealth {
  isConfigured: boolean;
  tokenError: string | null;
  tokenErrorAt: string | null;
}

/**
 * Leest de gezondheid van de Meta WhatsApp-koppeling uit `whatsapp_settings`.
 * `tokenError` is niet-null zodra de laatste verzending faalde door een
 * verlopen/ongeldig Meta access token (gezet door de send-whatsapp edge
 * function). De banner in de Layout gebruikt dit om te waarschuwen.
 *
 * Alleen ingeschakeld voor beheerders, aangezien alleen zij het token
 * kunnen vernieuwen.
 */
export function useWhatsAppHealth(enabled: boolean) {
  const query = useQuery({
    queryKey: ['whatsapp', 'health'],
    queryFn: async (): Promise<WhatsAppHealth> => {
      const { data, error } = await supabase
        .from('whatsapp_settings')
        .select('is_configured, token_error, token_error_at')
        .maybeSingle();

      if (error) throw error;

      return {
        isConfigured: data?.is_configured ?? false,
        tokenError: data?.token_error ?? null,
        tokenErrorAt: data?.token_error_at ?? null,
      };
    },
    enabled,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });

  return {
    health: query.data ?? null,
    isLoading: query.isLoading,
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
}
